import { useContext } from 'react';
import { AuthenticationContext } from 'contexts';
import { AuthenticationContextValue } from 'models';

export function useAuthentication(): AuthenticationContextValue {
  const context = useContext(AuthenticationContext) as unknown as AuthenticationContextValue;
  if (!context) {
    throw new Error('useAuthentication must be used within AuthenticationProvider');
  }
  return context;
}